import { IGosContractGoodsViewDTO } from "../../../../../libs/coreapi-dto/dirs/gosContract";
import { Action } from "./actionType"

export interface IInitialState {
    items: IGosContractGoodsViewDTO[]
    totalCount: number
}

export const initialState: IInitialState = {
    items: [],
    totalCount: 0
};

export function reducer(state: IInitialState = initialState, action: Action): IInitialState {
    switch (action.type) {
        case 'setItems':
            return { ...state, items: [...action.payload.items], totalCount: action.payload.totalCount }
        default:
            return state;
    }
}